import "core-js";
import "settings";

import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";
import "jquery-serializejson";
import Page from "webPage/Page";
import { handleStickyNav } from "util/handleStickyNav.js";
import loadLatestTweet from "util/loadLatestTweet.js";

window.$ = jQuery;

$(function () {
    Page.init();

    let windowWidth;
    handleStickyNav();

    let $header_page_overlay = $('.js-header-overlay');

    $(window).on('resize load', function () {
        windowWidth = $(window).outerWidth();
    });

    $('body').on('click', '.js-toggle-nav-dropdown', function () {
        $('body').toggleClass('sub-nav-active');
        if (windowWidth < 1280) {
            let $parentNavItem = $(this).parent('.nav__item--dropdown');
            let $siblingNavDropdown = $(this).parent('.nav__item').find('.nav-dropdown');

            $('.account-login--active').removeClass('account-login--active');

            if ($siblingNavDropdown.hasClass('nav-dropdown--active')) {
                $parentNavItem.removeClass('nav__item--active');
                $siblingNavDropdown.removeClass('nav-dropdown--active');
                $header_page_overlay.removeClass('active');

                return false;
            } else {
                $('.nav__item--active').removeClass('nav__item--active');
                $('.nav-dropdown--active').removeClass('nav-dropdown--active');

                setTimeout(function () {
                    $siblingNavDropdown.addClass('nav-dropdown--active');
                    $parentNavItem.addClass('nav__item--active');
                    $header_page_overlay.addClass('active');
                });
            }
            return false;
        }
    }).on('mouseover', '.nav__item--dropdown, .sub-nav a, .js-account-login', function () {
        if (windowWidth >= 1280) {
            $header_page_overlay.removeClass('header-overlay--out-active');
            $header_page_overlay.addClass('header-overlay--active');
        }
    }).on('mouseout', '.nav__item--dropdown, .sub-nav a, .js-account-login', function () {
        if (windowWidth >= 1280) {
            $header_page_overlay.removeClass('header-overlay--active');
            $header_page_overlay.addClass('header-overlay--out-active');
        }
    }).on('click', '.js-toggle-mobile-menu', function () {
        $('body').toggleClass('nav-active');
        return false;
    }).on('click', '.js-close-nav-dropdown', function () {
        $(this).parents('.nav-dropdown').removeClass('nav-dropdown--active');
        $('body').removeClass('sub-nav-active');
        return false;
    }).on('click', '.js-toggle-account-login', function () {
        if (windowWidth < 1024) {
            $(this).parent('.account-login').find('.account-login__dropdown').stop().slideToggle();
        } else if (windowWidth >= 1024 && windowWidth < 1280) {
            $(this).parent('.account-login').toggleClass('account-login--active');
            $header_page_overlay.toggleClass('active', $(this).parent('.account-login').hasClass('account-login--active'));
            $('.nav__item--dropdown').removeClass('nav__item--active');
            $('.nav-dropdown').removeClass('nav-dropdown--active');
        }
        return false;
    });

    let $latest_tweet_container = $('.js-ajax-tweet');
    if ($latest_tweet_container.length > 0) {
        $latest_tweet_container.each(function () {
            loadLatestTweet($(this));
        });
    }
});

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
